<template>
  <div class="ec-week-hr">
    <div v-for="(service, ind) in jobsPerHour" :key="ind">
      <CPopover placement="right" trigger="hover">
        <template #toggler="{ on }">
          <v-btn
            rounded="xl"
            variant="flat"
            size="x-small"
            :class="'bg-' + serviceColors[ind]"
            v-on="on"
            >{{ service.length }}</v-btn
          >
        </template>
        <template #content>
          <div class="popup-header" :class="'bg-' + serviceColors[ind]">
            {{ getDescription(ind) }}
          </div>
          <v-list>
            <v-list-item v-for="(ser, index) in service" :key="index">
              <v-list-item-title
                ><b
                  >{{
                    ser.customer.firstname +
                    " " +
                    ser.customer.lastname.charAt(0)
                  }}
                </b>
                {{ ":  " + processedDateTime(ser.datetime) }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </template>
      </CPopover>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import { serviceColors, servicesList } from "../../libs/options";
import { CPopover } from "@coreui/vue";

const props = defineProps({
  jobsPerHour: {
    type: Object,
    default: () => {},
  },
});

const getDescription = function (ind) {
  const service = servicesList.find((service) => {
    return service.id === ind;
  });
  return service.description;
};

const processedDateTime = function (dt) {
  let date = new Date(dt);
  let minutes = ("0" + date.getUTCMinutes()).slice(-2);
  return date.getUTCHours() + ":" + minutes;
};
</script>

<style>
.ec-week-hr {
  height: 100px;
  display: flex;
  flex-wrap: wrap;
}
.ec-week-hr-service {
  height: 20px;
  width: 20px;
  margin: 5px;
  border-radius: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
}
</style>
